import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint';
import gsap from "gsap";

export default class OldCity extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, visitedPinColor) {
		super();

		this.setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick);
	}

	setupPin(pinColor, pinColorDark, visitedPinColor, camera, interactionManager, onPinClick) {
		this.pinModel4 = new Heatpoint(null, "model/heatointoldcity.glb");
		setTimeout(() => {
			this.pinModel4.setColor(pinColor);
		}, 1000);
		
		this.pinModel4.position.set(-0.41, 0.40, 0.17);
		this.visited = false;
		interactionManager.add(this.pinModel4);

		this.pinModel4.addEventListener("click", () => this.onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick));
		this.pinModel4.addEventListener('mouseover', () => this.onMouseOver(pinColorDark));
		this.pinModel4.addEventListener('mouseout', () => this.onMouseOut(pinColor, visitedPinColor));

		this.add(this.pinModel4);
		
		this.rotationAngle = 0;
		this.rotatePin();
	}

	onPinClick(pinColor, pinColorDark, visitedPinColor, camera, onPinClick) {
		onPinClick();
		gsap.to(camera.position, { x: -1.5, y: 1.1, z: 1.1, duration: 2.5, ease: "Power3.inOut" });
		this.visited = true;
		
		setTimeout(() => {
			document.getElementById('modal5').classList.remove('hidden');
		}, 3000);
	}

	onMouseOver(pinColorDark) {
		document.body.style.cursor = 'pointer';
		this.pinModel4.setColor(pinColorDark);
	}

	onMouseOut(pinColor, visitedPinColor) {
		document.body.style.cursor = 'default';
		this.pinModel4.setColor(this.visited ? visitedPinColor : pinColor);
	}

	rotatePin() {
		this.rotationData = { angle: 0 };
		gsap.to(this.rotationData, {
			angle: "+=" + 2 * Math.PI,
			duration: 10,
			ease: "none",
			onUpdate: () => {
				this.pinModel4.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
			},
			repeat: -1
		});
	}
}
